export const D03 = {
    "columns": 12,
    "rows": 2,
    "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": "colorTheme1",
        "title": "Sales by Channel (Actual vs Last Year)",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'Channel',
                        "columnName": 'DistributorCode',
                        "width": '140px',
                        "align": "left",
                        "sortable": true,
                        "sum": false
                    },
                    {
                        "name": 'Channel Name',
                        "columnName": 'DistributorName',
                        "width": '35%',
                        "align": "left",
                        "sortable": true,
                        "sum": false
                    },
                    {
                        "name": 'Actual Sales',
                        "columnName": 'ActualSales(Value)',
                        "width": '140px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": 'LY Sales',
                        "columnName": 'LYSales(Value)',
                        "width": '130px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": 'Growth %',
                        "columnName": 'Growth(Value)',
                        "width": '130px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    }
                ],
                "title": 'DistributorName',
                "endpoint": "D03",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "DistrictManagerCode", "value": "" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {
                        "selectedValueColumn": "DistributorCode",
                        "selectedTitle": "Customer",
                        "visual": [
                            {
                                "columns": 12,
                                "rows": 2,
                                "visual": {
                                    "id": 1,
                                    "type": "advancedTable",
                                    "colorTheme": "colorTheme1",
                                    "title": "Customer",
                                    "binding": {
                                        "data": {
                                            "columns": [
                                                {
                                                    "name": 'Customer Name',
                                                    "columnName": 'CustomerName',
                                                    "width": '250px',
                                                    "align": "left",
                                                    "sortable": true,
                                                    "sum": false
                                                },
                                                {
                                                    "name": 'Actual Sales',
                                                    "columnName": 'ActualSales(Value)',
                                                    "width": '140px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                },
                                                {
                                                    "name": 'LY Sales',
                                                    "columnName": 'LYSales(Value)',
                                                    "width": '135px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                },
                                                {
                                                    "name": 'Growth %',
                                                    "columnName": 'Growth(Value)',
                                                    "width": '135px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": false,
                                                    "percent": true
                                                }
                                            ],
                                            "title": 'CustomerName',
                                            "endpoint": "D03.1",
                                            "parameters": [
                                                { "key": "FromMonth", "value": "2024" },
                                                { "key": "FromYear", "value": "1" },
                                                { "key": "ToMonth", "value": "2024" },
                                                { "key": "ToYear", "value": "1" },
                                                { "key": "DistrictManagerCode", "value": "" },
                                                { "key": "DistributorCode", "value": "" },
                                                { "key": "ConfigTypeCode", "value": "" }
                                            ]
                                        },
                                        "context": {
                                            "point": {
                                                "onClick": {
                                                    "selectedValueColumn": "DistributorCustomerName",
                                                    "selectedTitle": "Product",
                                                    "visual": [
                                                        {
                                                            "columns": 12,
                                                            "rows": 2,
                                                            "visual": {
                                                                "id": 1,
                                                                "type": "advancedTable",
                                                                "colorTheme": "colorTheme1",
                                                                "title": "Product",
                                                                "binding": {
                                                                    "data": {
                                                                        "columns": [
                                                                            {
                                                                                "name": 'Product Name',
                                                                                "columnName": 'ItemName',
                                                                                "width": '200px',
                                                                                "align": "left",
                                                                                "sortable": true,
                                                                                "sum": false
                                                                            },
                                                                            {
                                                                                "name": 'Actual Sales',
                                                                                "columnName": 'ActualSales(Value)',
                                                                                "width": '140px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": true
                                                                            },
                                                                            {
                                                                                "name": 'LY Sales',
                                                                                "columnName": 'LYSales(Value)',
                                                                                "width": '135px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": true
                                                                            },
                                                                            {
                                                                                "name": 'Growth %',
                                                                                "columnName": 'Growth(Value)',
                                                                                "width": '135px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": false,
                                                                                "percent": true
                                                                            }
                                                                        ],
                                                                        "title": 'ItemName',
                                                                        "endpoint": "D03.2",
                                                                        "parameters": [
                                                                            { "key": "FromMonth", "value": "2024" },
                                                                            { "key": "FromYear", "value": "1" },
                                                                            { "key": "ToMonth", "value": "2024" },
                                                                            { "key": "ToYear", "value": "1" },
                                                                            { "key": "DistrictManagerCode", "value": "" },
                                                                            { "key": "DistributorCustomerName", "value": "" },
                                                                            { "key": "ConfigTypeCode", "value": "" }
                                                                        ]
                                                                    },
                                                                    "context": {
                                                                        "point": {
                                                                            "onClick": {

                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        ]

                    }
                }
            }
        }
    }
}